<template>
    <div>
        <div class="flex flex-col w-full">
            <!-- price range -->
            <!-- <div class="mb-6 ">
                <div class="mb-1 font-semibold">
                    Price Range
                </div>
                <div class="p-2 pt-8 bg-gray-100 border rounded">
                    <VueRangeSlider
                        ref="slider"
                        v-model="priceRange"
                        :bg-style="bgStyle"
                        :tooltip-style="tooltipStyle"
                        :process-style="processStyle"
                        :min="min"
                        :max="max"
                        :tooltip-merge="false"
                        :enable-cross="true"
                    />
                </div>
            </div> -->

            <!-- <div /> -->

            <!-- Wholesaler -->
            <!-- <div class="mb-6">
                <div class="mb-1 font-semibold">
                    Wholesaler
                </div>
                <ul class="bg-gray-100 border rounded">
                    <li
                        v-for="wholesaler in wholesalers"
                        :key="'wholesaler' + wholesaler.id"
                        class="px-3 py-2 cursor-pointer hover:bg-gray-50"
                        @click="
                            wholesalerIds = [wholesaler.id];
                            fetchFilteredProducts();
                        "
                    >
                        <p class="line-clamp-1 hover:text-green-500">
                            {{ wholesaler.name }}
                        </p>
                    </li>
                    <li
                        v-if="wholesalers.length >= 10"
                        class="px-3 py-2"
                        @click="goto('wholesalers.index')"
                    >
                        <div class="inline-block px-2 py-1 text-xs text-white bg-green-500 rounded cursor-pointer hover:bg-green-400">
                            View more
                        </div>
                    </li>
                </ul>
            </div> -->

            <!-- category -->
            <div class="mb-6 ">
                <div class="mb-1 font-semibold">
                    Category
                </div>
                <ul class="bg-gray-100 border rounded">
                    <li
                        v-for="category in categories.filter(eachCategory=>eachCategory.parent_id !== null)"
                        :key="'category' + category.id"
                        class="px-3 py-2 cursor-pointer hover:text-green-500"
                        @click="
                            categoryIds = [category.id];
                            fetchFilteredProducts();
                        "
                    >
                        <p class="line-clamp-1">
                            {{ category.name }}
                        </p>
                    </li>
                    <li
                        v-if="categories.length >= 10"
                        class="px-3 py-2"
                        @click="goto('categories.index')"
                    >
                        <div class="inline-block px-2 py-1 text-xs text-white bg-green-500 rounded cursor-pointer hover:bg-green-400">
                            View more
                        </div>
                    </li>
                </ul>
            </div>

            <!-- brand -->
            <!-- <div class="mb-4 ">
                <div class="mb-1 font-semibold">
                    Brands
                </div>
                <ul class="bg-gray-100 border rounded">
                    <li
                        v-for="brand in brands"
                        :key="'brand' + brand.id"
                        class="flex items-center p-3 cursor-pointer hover:text-green-500"
                        @click="
                            brandIds = [brand.id];
                            fetchFilteredProducts();
                        "
                    >
                        <img
                            :src="
                                brand.images.length
                                    ? brand.images[0].image_path
                                    : `https://ui-avatars.com/api/?name=${brand.name}&color=7F9CF5&background=EBF4FF`
                            "
                            :alt="brand.name"
                            class="h-8 mr-4 "
                        >
                        <p class="line-clamp-1">
                            {{ brand.name }}
                        </p>
                    </li>
                    <li
                        v-if="brands.length >= 10"
                        class="px-3 py-2"
                        @click="goto('brands.index')"
                    >
                        <div

                            class="inline-block px-2 py-1 text-xs text-white bg-green-500 rounded cursor-pointer hover:bg-green-400"
                        >
                            View more
                        </div>
                    </li>
                </ul>
            </div> -->
        </div>
    </div>
</template>

<script>
import _ from 'lodash';
import 'vue-range-component/dist/vue-range-slider.css';
// import VueRangeSlider from 'vue-range-component';
import common from '../common';

export default {
    name: 'ProductFilters',

    // components: {
    //     VueRangeSlider,
    // },

    props: {
        products: {
            type: Array,
            required: true,
        },
        wholesalers: {
            type: Array,
            required: true,
        },
        categories: {
            type: Array,
            required: true,
        },
        brands: {
            type: Array,
            required: true,
        },
        appliedFilters: {
            type: Object,
            required: true,
        },
        sortBy: {
            type: String,
            default: null,
        },
    },

    data() {
        return {
            common,
            mounted: false,
            priceRange: [common.minPrice, common.maxPrice],
            min: common.minPrice,
            max: common.maxPrice,
            categoryIds: [],
            wholesalerIds: [],
            brandIds: [],
            bgStyle: {
                backgroundColor: '#fff',
                boxShadow: 'inset 0.5px 0.5px 3px 1px rgba(0,0,0,.36)',
            },
            tooltipStyle: {
                backgroundColor: '#047857',
                borderColor: '#047857',
            },
            processStyle: {
                backgroundColor: '#10B981',
            },
        };
    },

    watch: {
        sortBy() {
            this.fetchFilteredProducts();
        },

        priceRange: {
            deep: true,
            handler(val) {
                if (val.length === 2 && this.mounted) {
                    this.debouncedFetchFilteredProducts();
                }
            },
        },
    },

    mounted() {
        if (this.appliedFilters.categoryIds && this.appliedFilters.categoryIds.length) {
            this.categoryIds = Array.from(new Set(this.appliedFilters.categoryIds.map((elem) => parseInt(elem, 10))));
        }
        if (this.appliedFilters.wholesalerIds && this.appliedFilters.wholesalerIds.length) {
            this.wholesalerIds = Array.from(new Set(this.appliedFilters.wholesalerIds.map((elem) => parseInt(elem, 10))));
        }
        if (this.appliedFilters.brandIds && this.appliedFilters.brandIds.length) {
            this.brandIds = Array.from(new Set(this.appliedFilters.brandIds.map((elem) => parseInt(elem, 10))));
        }
        this.priceRange = [
            this.appliedFilters.minPrice ?? this.priceRange[0],
            this.appliedFilters.maxPrice ?? this.priceRange[1],
        ];

        this.debouncedFetchFilteredProducts = _.debounce(this.fetchFilteredProducts, 3000);

console.log(this.debouncedFetchFilteredProducts);

        this.$nextTick(() => {
            this.mounted = true;
        });
    },

    methods: {
        fetchFilteredProducts() {
            if (this.$page.url.includes('/search/')) {
                this.$inertia.get(
                    route('search.show', {
                        keyword: this.appliedFilters.keyword,
                        minPrice: this.priceRange[0],
                        maxPrice: this.priceRange[1],
                        categoryIds: this.categoryIds,
                        wholesalerIds: this.wholesalerIds,
                        brandIds: this.brandIds,
                        sortBy: this.sortBy,
                    })
                );
            } else {
                this.$inertia.get(
                    route('products.index', {
                        minPrice: this.priceRange[0],
                        maxPrice: this.priceRange[1],
                        categoryIds: this.categoryIds,
                        wholesalerIds: this.wholesalerIds,
                        brandIds: this.brandIds,
                        sortBy: this.sortBy,
                    })
                );
            }
        },

        clearAll() {
            this.$inertia.get(route('products.index'));
        },
    },
};
</script>
